import { useState, useEffect } from "react";
import BounceLoader from "react-spinners/BounceLoader";
import Row from 'react-bootstrap/Row';
import { useSearchParams } from 'react-router-dom';

const VerifyQR = (props) => {
  const [searchParams] = useSearchParams();
  const bookId = searchParams.get('bookId');
  const qrCodeId = searchParams.get('qrCodeId');
  const contentype = searchParams.get('contentype');
  const sequential = searchParams.get('sequential');

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Detect device type
    const isAndroid = /Android/i.test(navigator.userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

    // Fallback URLs for app stores - direct links to app stores
    const fallbackURL = isAndroid
      ? 'https://play.google.com/store/apps/details?id=com.yellow.tya'
      : isIOS
        ? 'https://apps.apple.com/us/app/the-yellow-app/id6744366583'
        : 'https://app.theyellowapp.com';

    // Define content paths (no longer used for iOS)
    let videoContent, intermissionContent;

    if (isIOS) {
      // Immediately redirect to App Store for iOS
      window.location.href = fallbackURL;
      return;
    } else if (isAndroid) {
      // Use custom scheme for Android
      videoContent = `linking-app://app/VerifySequence?contentype=${contentype}&qrcodeID=${qrCodeId}&bookId=${bookId}&sequential=${sequential}`;
      intermissionContent = `linking-app://app/Comments?contentype=${contentype}&qrcodeID=${qrCodeId}&bookId=${bookId}`;
    } else {
      // Fallback for other platforms
      const baseUrl = "linking-app:/";
      videoContent = `${baseUrl}/app/VerifySequence?contentype=${contentype}&qrcodeID=${qrCodeId}&bookId=${bookId}&sequential=${sequential}`;
      intermissionContent = `${baseUrl}/app/Comments?contentype=${contentype}&qrcodeID=${qrCodeId}&bookId=${bookId}`;
    }

    const openApp = () => {
      let hidden = false;

      const handleVisibilityChange = () => {
        if (document.hidden) {
          hidden = true;
        }
      };

      document.addEventListener('visibilitychange', handleVisibilityChange);

      if (contentype === "video") {
        window.location.href = videoContent;
      } else if (contentype === "intermission") {
        window.location.href = intermissionContent;
      }

      setTimeout(() => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        if (!hidden) {
          window.location.href = fallbackURL;
        }
      }, 1500);
    };

    openApp();
  }, [bookId, qrCodeId, contentype]);

  return (
    <div>
      <div className="d-flex justify-content-center mt-5">
        <img src={`/logo192.png`} alt="logo" style={{ height: 150, marginTop: 20, marginBottom: 100 }} />
      </div>
      <Row className="text-center mt-5">
        <BounceLoader
          cssOverride={{ display: "block", margin: "0 auto" }}
          size={80}
          color={"#ffd600"}
          loading={loading}
          speedMultiplier={1}
          aria-label="Loading Spinner"
          data-testid="loader"
        />
      </Row>
      <Row className="text-center mt-2">
        <strong style={{ fontSize: 23 }}>Verifying QR Code... </strong>
      </Row>
    </div>
  );
};

export default VerifyQR;
